export var DiscountMeasure;
(function (DiscountMeasure) {
    DiscountMeasure["percent"] = "%";
    DiscountMeasure["sum"] = "$";
})(DiscountMeasure || (DiscountMeasure = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["cash"] = "cash";
    PaymentMethod["card"] = "card";
    PaymentMethod["guarantee"] = "guarantee";
    PaymentMethod["userBalance"] = "userBalance";
    PaymentMethod["other"] = "other";
    PaymentMethod["mobile"] = "mobilePayment";
})(PaymentMethod || (PaymentMethod = {}));
